
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKULaborDialog extends Common.GridEditorDialog<SKULaborRow> {
        protected getFormKey() { return SKULaborForm.formKey; }
        //protected getIdProperty() { return SKULaborRow.idProperty; }
        protected getLocalTextPrefix() { return SKULaborRow.localTextPrefix; }
        //protected getNameProperty() { return SKULaborRow.nameProperty; }
        //protected getService() { return SKULaborService.baseUrl; }
        protected getDeletePermission() { return SKULaborRow.deletePermission; }
        protected getInsertPermission() { return SKULaborRow.insertPermission; }
        protected getUpdatePermission() { return SKULaborRow.updatePermission; }

        protected form = new SKULaborForm(this.idPrefix);

    }
}